const MIN_VALUE = 1;
const MAX_VALUE = Infinity;

/**
 * Dispatches a form change event, so the auto-submit plugin from Shopware
 * also works with this custom input.
 * @param {HTMLInputElement} $input
 */
const dispatchChange = (e, $input) => {
    // Shopware 6 comes with Element.closest polyfill already
    const $form = $input.closest('form');
    
    if (!$form) {
        return;
    }

    const event = document.createEvent('HTMLEvents');
    event.initEvent('change', false, true);
    $form.dispatchEvent(event);
}

/**
 * Increments the value of the input.
 *
 * @param {HTMLInputElement} $input
 */
const increment = ($input, e) => {
    const value = parseInt($input.value, 10);
    const nextValue = value + 1;

    if (nextValue > MAX_VALUE) {
        return;
    }

    $input.value = nextValue.toString();
    dispatchChange(e, $input);
};

/**
 * Decrements the value of the input.
 *
 * @param {HTMLInputElement} $input
 */
const decrement = ($input, e) => {
    const value = parseInt($input.value, 10);
    const nextValue = value - 1;

    if (nextValue < MIN_VALUE) {
        return;
    }

    $input.value = nextValue.toString();
    dispatchChange(e, $input);
};

/**
 * Validates the value and resets it, if it happens to be invalid.
 *
 * @param {HTMLInputElement} $input
 */
const verify = ($input, e) => {
    const value = parseInt($input.value, 10);

    if (value < MIN_VALUE) {
        $input.value = MIN_VALUE.toString();
    } else if (value > MAX_VALUE && MAX_VALUE !== Infinity) {
        $input.value = MAX_VALUE.toString();
    }
};

/**
 * Attaches event listeners to a stepper.
 *
 * @param $stepper
 */
const initialize = $stepper => {
    const $input = $stepper.querySelector('input[type="number"]');
    if (!$input) {
        return;
    }

    $input.addEventListener('blur', verify.bind(event, $input));

    const $incrementButton = $stepper.querySelector('.sm-stepper__increment');
    if ($incrementButton) {
        $incrementButton.addEventListener(
            'click',
            increment.bind(event, $input),
        );
    }

    const $decrementButton = $stepper.querySelector('.sm-stepper__decrement');
    if ($decrementButton) {
        $decrementButton.addEventListener(
            'click',
            decrement.bind(event, $input),
        );
    }
};

/**
 * Collects all steppers from DOM and calls the initialize method on them.
 */
export default () => {
    const $steppers = document.querySelectorAll('.sm-stepper');
    $steppers.forEach(initialize);
};
